import { render } from "./TgBtn.vue?vue&type=template&id=1c43a284"
import script from "./TgBtn.vue?vue&type=script&lang=js"
export * from "./TgBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__